<template>
  <div class="wrapper">
    <slot />
  </div>
</template>

    <style scoped>
      .wrapper {
        display: flex;
        height: 100%;
        overflow: hidden;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
      }
    </style>
